import { enableProdMode, importProvidersFrom } from "@angular/core";
import { AppComponent } from "src/app/app.component";
import { MatDialogModule } from "@angular/material/dialog";
import { provideAnimations } from "@angular/platform-browser/animations";
import { bootstrapApplication } from "@angular/platform-browser";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { AuthInterceptor } from "src/app/_helpers/auth.interceptor";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { PreloadAllModules, provideRouter, withPreloading } from "@angular/router";
import { ROUTES } from "src/app/app-routes";
import { GetLoaderJsonPipe } from "src/app/_components/dello-loader/pipes/get-loader-json.pipe";
import { provideLottieOptions } from "ngx-lottie";
import { NgxEchartsModule } from "ngx-echarts";
import * as echarts from "echarts";
import { environment } from "src/environments/environment";
import { EnvironmentTypeEnum } from "src/app/_enums/environment-type.enum";
import { CoreInjectorTokensV2 } from "src/app/_enums/core-injector-tokens";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { CustomPaginationTemplate } from "src/app/_helpers/custom-pagination-template";

/* eslint-disable */
// @ts-ignore
if ([EnvironmentTypeEnum.PROD, EnvironmentTypeEnum.STAGE, EnvironmentTypeEnum.DEMO].includes(environment.type)) {
    enableProdMode();
}

const CUSTOM_FORMATS = {
    parse: {
        dateInput: ["LL", "L"],
        timeInput: ["hh:mm A", "HH:mm"],
    },
    display: {
        dateInput: "MM/DD/YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "DD/MM/yyyy",
        monthYearA11yLabel: "MMMM YYYY",
        timeInput: "hh:mm A",
        timeOptionLabel: "hh:mm A",
    },
};

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            MatDialogModule,
            NgxEchartsModule.forRoot({ echarts }),
        ),
        GetLoaderJsonPipe,
        provideLottieOptions({
            player: () => import("lottie-web"),
        }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [
                MAT_DATE_LOCALE,
                MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            ],
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: CUSTOM_FORMATS,
        },
        {
            provide: CoreInjectorTokensV2.Environment,
            useValue: environment
        },
        {
            provide: CoreInjectorTokensV2.LoginUrl,
            useValue: "/auth/login"
        },
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginationTemplate,
        },
        provideRouter(ROUTES, withPreloading(PreloadAllModules)),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ],
}).catch((err) => console.error(err));
